<template>
  <fieldset>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Länk</div>
      </div>
      <input class="form-control" required readonly :value="route('integrations.disableAutomations')">
    </div>

    <p class="small">
      Identiska anrop skyddas automatiskt i 24 timmar. En egen <code>Idempotency-Key</code> kan användas för kontrollerade återförsök.
    </p>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Maila säljare om flera offerter matchar</div>
        </div>
        <select class="custom-select" v-model="emailSellersOnMultiDisable" @change="onUpdate">
          <option :value="false">Nej</option>
          <option :value="true">Ja</option>
        </select>
      </div>
    </div>

    <p>Använd följande dataformat i JSON:</p>
    <pre><code>
      {
        uuid: "{{uuid}}", // Must always be this specific value
        customer_email: String|null,
        customer_phone: String|null, // +46NNNNNNNNN
      }
    </code></pre>
  </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
import { v4 as uuidv4 } from 'uuid';
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const uuid = ref(null);
const emailSellersOnMultiDisable = ref(null);
const serializedValue = computed(() => {
  return {
    uuid: uuid.value,
    email_sellers_on_multi_disable: emailSellersOnMultiDisable.value
  };
});
function onUpdate() {
  emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    uuid.value = modelValue.value.uuid;
    emailSellersOnMultiDisable.value = modelValue.value.email_sellers_on_multi_disable;
  }
  if (!uuid.value) {
    uuid.value = uuidv4();
  }
  if (emailSellersOnMultiDisable.value !== true && emailSellersOnMultiDisable.value !== false) {
    emailSellersOnMultiDisable.value = false;
  }
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    onUpdate();
  }
}, {
  immediate: true
});
</script>
